<script>
    import Reporter from "../../lib/error.js";
    import { isOwnerOfProject } from "../../Me.svelte";
    import { allProjectFields, addContribution } from "../../Participaid.svelte";
    import ProjectFieldLib from "../../models/participaid/ProjectField.js";

    import Dialog from "../Dialog.svelte";
    import Name from "../Name.svelte";
    import Emoji from "../Emoji.svelte";
    import Field from "../form/Field.svelte";
    import UrlField from "../form/UrlField.svelte";
    import ImageUploadField from "../form/ImageUploadField.svelte";
    import Button from "../form/Button.svelte";
    import Messages from "../form/Messages.svelte";
    import Message from "../form/Message.svelte";
    import LoadingModal from "../LoadingModal.svelte";
    import ContributorDropdown from "../form/ContributorDropdown.svelte";
    import ProjectFieldDropdown from "../form/ProjectFieldDropdown.svelte";
    import ProjectTitleTag from "../ProjectTitleTag.svelte";
    import AttachmentUploadField from "../form/AttachmentUploadField.svelte";
    import EntryTags from "../form/EntryTags.svelte";
    import TextField from '../form/TextField.svelte';
    import TimeField from "../form/TimeField.svelte";

    import {Input, Textarea} from '@smui/textfield';
    import Icon from '@smui/textfield/icon/index';
    import HelperText from '@smui/textfield/helper-text/index';
    import {Icon as CommonIcon} from '@smui/common';
    import FloatingLabel from '@smui/floating-label';
    import LineRipple from '@smui/line-ripple';
    import NotchedOutline from '@smui/notched-outline';
    import Datepicker from "svelte-calendar/src/Components/Datepicker.svelte";
    import {Label} from '@smui/button';
    import CharacterCounter from '@smui/textfield/character-counter/index';
    import Media from '@smui/card';

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    // TODO: expose to user config
    const AUTO_ACCEPT_PROJECT_OWNER_ENTRIES = false;

    // whether this dialog should be shown
    export let show = true;

    // project model
    export let project;
    export let meUserId;
    export let targetUserId;
    export let isOwner;
    export let description = "";
    export let typeField;
    export let typeFieldId;
    export let inputHours = 0;
    export let inputMinutes = 0;
    export let inputCurrency = 0;
    export let contributionDate = new Date();

    let isProjectOwner = isOwner || isOwnerOfProject(meUserId, project);
    let isForMe = !targetUserId || targetUserId == meUserId;
    let headerBackground = project.avatarUrl || `https://picsum.photos/400/270?_pid=${project.id}`;

    // submission request states
    let errorResult;
    let submitRequest;

    let selectedTargetContributorId;

    // TODO: properly calculate using administrationperiod logic
    let dateBoundary = new Date();
    dateBoundary.setDate(dateBoundary.getDate() - 7);

    const maxDescriptionLength = 300;

    let tags = [];

    $: typeFieldInputType = ProjectFieldLib.getFieldInputType(typeField);
    $: isCurrencyType = typeFieldInputType == "currency";
    $: isTimeType = ["time", "hours"].includes(typeFieldInputType);
    $: timeHourValue = (((inputHours * 60) + inputMinutes) / 60).toFixed(2);
    $: hasTimeInput = !!inputHours || !!inputMinutes;
    $: typeFieldSelected = !!typeFieldInputType;
    $: inputValue = isCurrencyType ? (inputCurrency * 100) : (isTimeType ? timeHourValue : null);
    $: isValidInput = (isCurrencyType && !!inputCurrency) || (isTimeType && hasTimeInput);
    $: isValid = typeFieldSelected && !!description && isValidInput;
    $: tagsAvailable = project && (project.contributions || []).map(contribution => contribution.tags.trim().split(","));
    $: { console.log(`tags changed" ${tags}`) }

    $: validationComponents = {
        typeFieldId,
        typeFieldInputType,
        description,
        inputCurrency,
        inputHours,
        inputMinutes,
        isCurrencyType,
        isTimeType,
        hasTimeInput,
        timeHourValue
    };

    $: contributionInput = {...{
        description,
        tags: tags.join(","),
        contributionDate: contributionDate.toISOString(),
        collaboratorUser: targetUserId ? { id: targetUserId } : null,
        inputValue: {
            name: typeField && typeField.name,
            unit: typeFieldInputType,
            value: "" + inputValue
        }
    }, ...(isOwner ? { review: {
            acceptanceStatus: (isProjectOwner && AUTO_ACCEPT_PROJECT_OWNER_ENTRIES) ? "ACCEPTED" : "ACCEPTANCE_PENDING"
        }} : {}
    )};

    /*$: if (typeFieldId || typeFieldInputType || description) {
        console.log(`input field changed!`);
        console.log(validationComponents);
    }*/

    function create() {
        debugger;
        submitRequest = addContribution(project.id, typeFieldId, contributionInput)
            .then(res => {
                console.log(`Successfully created entry!`);
                console.log(res);
                dispatch("new", res.data.addContribution);
            })
            // TODO: integrate into Dialog itself
            .catch(res => {
                Reporter.error("[NewEntryDialog] error trying to create Contribution", res);
                errorResult = res;
            });
    }

</script>

<Dialog
    {show}
    {headerBackground}
    class="dialog-new-entry"
    width={800}
    headerHeight={150}
    headerBackgroundPosition="center"
    request={submitRequest} >

    <header>
        <h1>New Entry <Emoji name="pencil2"/></h1>
        <span class="header-hint">
            Registering new entry for project: <ProjectTitleTag {project}/> {#if isProjectOwner}as owner{/if}
        </span>
    </header>

<!--    <EntryTags bind:current={tags} projectId={project.id}/>-->

    <form>
        <div class="column-left">
<!--            <Media class="card-media-16x9 dialog-header-background" aspectRatio="16x9" style="background-image: url({headerBackground})"/>-->

            <Messages>
                {#if errorResult}
                    <Message>{JSON.stringify(errorResult)}</Message>
                {/if}
            </Messages>
            {#if isProjectOwner && !targetUserId}
                <Field>
                    <ContributorDropdown
                            contributors={project.contributors}
                            help="The contributor to register this entry for"
                            fullwidth
                            style="width: 100%;"
                            bind:selected={selectedTargetContributorId}/>
                </Field>
            {/if}
            <Field>
                <ProjectFieldDropdown
                        bind:selectedFieldId={typeFieldId}
                        bind:selectedField={typeField}
                        {project}
                />
            </Field>

            <Field outline={true} label="Contribution date" help="When the actual contribution was dated." >
                <Datepicker
                        start={dateBoundary}
                        end={new Date()}
                        selected={contributionDate}
                        format={'#{d}/#{m}/#{Y}'}
                        buttonBackgroundColor='#e20074'
                        buttonTextColor='white'
                        highlightColor='#e20074'
                        dayBackgroundColor='#efefef'
                        dayTextColor='#333'
                        dayHighlightedBackgroundColor='#e20074'
                        dayHighlightedTextColor='#fff'
                />
            </Field>

            <Field>
                {#if isTimeType}
                    <TimeField bind:hours={inputHours} bind:minutes={inputMinutes}/>

                {:else if isCurrencyType}
                    <TextField
                            id="new-entry-input-currency"
                            style="width: 100%"
                            bind:value={inputCurrency}
                            label="Value brought in (€)"
                            type="number"
                            min="0"
                    >
                        <span slot="help">
                            Calculate or estimate the monetary value of the contribution brought in.
                        </span>
                    </TextField>

                {:else}
                    <!-- no fiel type selected... -->
                {/if}
            </Field>
            <Button id="button-step1" on:click={create} disabled={!isValid} style="width: 100%">
                <Label>Register entry</Label>
            </Button>
        </div>
        <div class="column-right">
            <Field style="height: 100%;">
                <TextField
                        class="new-entry-description"
                        style="height: 100%; width: 100%"
                        textarea
                        bind:value={description}
                        label="Contribution description"
                        placeholder="Worked on that report you asked for..."
                        input$aria-controls="helper-text-fullwidth-textarea"
                        input$aria-describedby="helper-text-fullwidth-textarea"
                        input$maxlength="{maxDescriptionLength}"
                >
                    <CharacterCounter>
                        0 / {maxDescriptionLength}
                    </CharacterCounter>
                </TextField>
                <HelperText id="helper-text-fullwidth-textarea">
                    A description of the contribution.
                </HelperText>
            </Field>
            <!-- TODO -->
<!--            <Field outline={true} style="margin: 0;">-->
<!--                <AttachmentUploadField/>-->
<!--            </Field>-->
        </div>

    </form>
</Dialog>

<style>
    form {
        margin: 25px 0;
        display: flex;
        flex-direction: row;
    }

    header {
        display: flex;
        padding: 20px 0;
    }

    h1 {
        text-align: left;
        margin: 0;
    }

    .header-hint {
        text-align: right;
        //margin: 25px 0;
        flex: 1;
        color: #999;
        font-style: italic;
        font-size: 12px;
    }

    .column-left, .column-right {
        position: relative;
    }

    .column-left {
        flex: 0;
    }

    .column-right  {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding-left: 25px;
        //padding-top: 128px;
    }
    :global(#button-step1) {
        margin: auto;
        //margin-top: 50px;
        display: inherit;
    }

    /* make sure the picker doesnt expand beyond the border of the dialog,
        which may have its overflow hidden for the header image */
    :global(.dialog-new-entry .datepicker .contents-wrapper) {
        top: -50px;
    }

    /* override style for tags component */
    :global(.dialog-new-entry .svelte-tags-input-layout) {
        border: 0 !important;
    }
</style>